exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  min-height: calc(100vh - 215px);\n}\n\n\nimg.main-content-image {\n  height: 0;\n  min-height: 23vh;\n  object-fit: cover;\n  object-position: center;\n}\n\n.di-title {\n  margin: 0;\n  padding: 7px;\n}\n\n.di_sm-section:first-child {\n  width: 50%;\n  padding-right: 5px;\n}\n\n.di_sm-section:last-child {\n  width: 50%;\n  padding-left: 5px;\n}\n\n.di_buttons {\n  padding-top: 10px;\n}\n\n.di_button:first-child {\n  padding-right: 5px;\n}\n\n.di_button:last-child {\n  padding-left: 5px;\n}\n\n.di_ads-sm-section {\n  width: 25%;\n  padding-right: 10px;\n}\n\n.di_ads-sm-section:nth-child(4),\n.di_ads-sm-section:nth-child(8) {\n  padding-right: 0;\n}\n\n@media screen and (max-width: 640px) {\n  .di_images-section,\n  .di_ads-images-section {\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .di_sm-section:first-child,\n  .di_sm-section:last-child,\n  .di_ads-sm-section {\n    width: 100%;\n  }\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/dynamic-images/dynamic-images.component.css
// module id = ../../../../../src/app/components/organization/captive-portal/dynamic-images/dynamic-images.component.css
// module chunks = main